// Tour Module
// Guided walkthrough state. Definitions and copy live in utils/setup/tourContent.js;
// the overlay that renders them is components/tours/TourOverlay.vue (mounted in
// App.vue so tours survive route changes). Context carries per-run values like
// the tracked brand's id/name for route params and copy interpolation.
import { TOURS } from '@/utils/setup/tourContent'

export default {
  namespaced: true,
  state: {
    activeTourId: null,
    stepIndex: 0,
    context: {}
  },
  getters: {
    getActiveTour: (state) => (state.activeTourId ? TOURS[state.activeTourId] : null),
    getActiveTourStep: (state, getters) => {
      const tour = getters.getActiveTour
      return tour ? tour.steps[state.stepIndex] : null
    },
    getTourStepIndex: (state) => state.stepIndex,
    getTourContext: (state) => state.context
  },
  mutations: {
    SET_ACTIVE_TOUR (state, { tourId, context }) {
      state.activeTourId = tourId
      state.stepIndex = 0
      state.context = context || {}
    },
    SET_STEP_INDEX (state, index) {
      state.stepIndex = index
    },
    SET_TOUR_CONTEXT (state, context) {
      state.context = { ...state.context, ...context }
    },
    CLEAR_TOUR (state) {
      state.activeTourId = null
      state.stepIndex = 0
      state.context = {}
    }
  },
  actions: {
    startTour ({ commit }, { tourId, context = {}, stepIndex = 0 }) {
      if (!TOURS[tourId]) return
      commit('SET_ACTIVE_TOUR', { tourId, context })
      if (stepIndex > 0) commit('SET_STEP_INDEX', stepIndex)
    },
    // Advances to the next step; resolves true when the tour just finished
    advanceTour ({ state, getters, commit }) {
      const tour = getters.getActiveTour
      if (!tour) return false
      if (state.stepIndex >= tour.steps.length - 1) return true
      commit('SET_STEP_INDEX', state.stepIndex + 1)
      return false
    },
    // Jumps straight to a step (used when the app reports an action the tour
    // was waiting on, possibly a step or two early); true when that runs the
    // tour off its end
    goToTourStep ({ getters, commit }, index) {
      const tour = getters.getActiveTour
      if (!tour) return false
      if (index >= tour.steps.length) return true
      commit('SET_STEP_INDEX', Math.max(0, index))
      return false
    },
    // Merge values learned mid-tour (e.g. the name of the board that was just
    // created) so later steps can interpolate them
    updateTourContext ({ state, commit }, context = {}) {
      if (!state.activeTourId) return
      commit('SET_TOUR_CONTEXT', context)
    },
    endTour ({ commit }) {
      commit('CLEAR_TOUR')
    }
  }
}
